import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { Link, generatePath } from 'react-router-dom'
import { Panel, Button } from 'rsuite'
import LegacyPlusIcon from '@rsuite/icons/legacy/Plus'
import LabelsGrid from '@components/marketing/labels/LabelsGrid'

import { ROUTE_MARKETING_LABEL_ADD } from '@@partner:config/routes'
import CommonSubTopMenu from '@components/common/subTopMenu/CommonSubTopMenu'

export default function LabelsPage () {
  const { brandSlug } = usePartner()

  return (
    <div>
      <LabelsGrid brandSlug={brandSlug} />
    </div>
  )
}
